import { render, staticRenderFns } from "./PluginInstallDialog.vue?vue&type=template&id=bc8fbc54"
import script from "./PluginInstallDialog.vue?vue&type=script&lang=ts"
export * from "./PluginInstallDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports